import { useFormik } from 'formik';
import * as Yup from 'yup';

const PracticeMainDetailsSchema = Yup.object().shape({
  practiceName: Yup.string().required('Name required'),
  taxonomy: Yup.string().required('Taxonomy required')
});

export default function usePracticeMainDetialsFormik(mainDetails = {}, onSubmit = () => {}) {
  const formik = useFormik({
    initialValues: {
      practiceName: mainDetails?.practiceName ?? '',
      dbaName: mainDetails?.dbaName ?? '',
      taxId: mainDetails?.taxId ?? '',
      taxIdType: mainDetails?.taxIdType ?? '',
      taxonomy: mainDetails?.taxonomy ?? '',
      practiceKind: mainDetails?.practiceKind ?? '',
      practiceStatus: mainDetails?.practiceStatus ?? ''
    },
    enableReinitialize: true,
    validationSchema: PracticeMainDetailsSchema,
    onSubmit
  });

  return formik;
}
